import {
    EMPTY_STATES,
    FETCH_STATES,
    FETCH_STATES_SUCCESS,
    RESTORE_STATES
} from "../ActionTypes"

export const fetchStates = (payload) => ({
    type: FETCH_STATES,
    payload
})

export const fetchStatesSuccess = (payload) => ({
    type: FETCH_STATES_SUCCESS,
    payload
})

export const emptyStates = () =>({
    type: EMPTY_STATES,
});

